import React from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";
import { Textbox } from "react-inputs-validation";

const DatosAsegurado = ({ dataRenovacion, obtenerNombreODenominacion, obtenerEdad }) => {
    if (!dataRenovacion || !dataRenovacion.reDatosAsegurado) return null;

    return (
        <Card className="flex-row">
            <CardBody>
                <h4 style={{ fontWeight: "bold" }}>Datos del Asegurado</h4>
                <p />
                {dataRenovacion.reDatosAsegurado.reIdentificacion ? (
                    <React.Fragment>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={dataRenovacion.reDatosAsegurado.reIdentificacion}
                                />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={obtenerNombreODenominacion(dataRenovacion.reDatosAsegurado)}
                                />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Edad</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={obtenerEdad(dataRenovacion.reDatosAsegurado)}
                                />
                            </Col>
                        </Row>
                        <Row>
                            {dataRenovacion.reDatosAsegurado.reEmail && (
                                <React.Fragment>
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <h5 style={{ fontWeight: "bold" }}>Email</h5>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <Textbox
                                            classNameInput="input-type-label form-control"
                                            value={dataRenovacion.reDatosAsegurado.reEmail}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                            {dataRenovacion.reDatosAsegurado.reDireccion && (
                                <React.Fragment>
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={12}>
                                        <Textbox
                                            classNameInput="input-type-label form-control"
                                            value={dataRenovacion.reDatosAsegurado.reDireccion}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                        </Row>
                    </React.Fragment>
                ) : (
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={dataRenovacion.reDatosAsegurado.reCodigoCliente}
                            />
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={`${dataRenovacion.reDatosAsegurado.reNombre1} ${dataRenovacion.reDatosAsegurado.reApellido1 || ''}`}
                            />
                        </Col>
                    </Row>
                )}
            </CardBody>
        </Card>
    );
};

export default DatosAsegurado;
